import JobListFiltersContainer from './job_list_filters_container';

const JobListFilters = JobListFiltersContainer;
export default JobListFilters;
